export default __webpack_public_path__ + "static/hero-module3x-04f1e25fed46cbe25a7965090771f496.webp";